export default {"src":"/_next/static/media/scan_svg.76caffdb.svg","height":88,"width":89,"blurWidth":0,"blurHeight":0};